import {
  type ILoggedUserInfo,
  UserService
} from "@frontiers-vue3/public-pages";
import { useAuthStore } from "~/stores/auth";

export default defineNuxtRouteMiddleware(async () => {
  const userService = new UserService();
  const authStore = useAuthStore();
  try {
    userService
      .getLoggedUserInfo()
      .then((loggedUserInfo: ILoggedUserInfo | undefined) => {
        if (loggedUserInfo && loggedUserInfo.id !== authStore.loggedUser?.id)
          authStore.setLoggedUser(loggedUserInfo);
      });
  } catch {
    authStore.unsetLoggedUser();
  }
});
